export default function (nip) {
	if (!nip) return false;

	nip = nip.replace(/-/g, '');
	if (nip.length !== 10) return false;

	const digits = nip.toString().split('');
	const sum = digits.reduce((acc, e, i) => {
		switch (i) {
			case 0:
				return acc + e * 6;
			case 1:
				return acc + e * 5;
			case 2:
				return acc + e * 7;
			case 3:
				return acc + e * 2;
			case 4:
				return acc + e * 3;
			case 5:
				return acc + e * 4;
			case 6:
				return acc + e * 5;
			case 7:
				return acc + e * 6;
			case 8:
				return acc + e * 7;
			default:
				return acc;
		}
	}, 0);

	return sum % 11 === parseInt(digits[9]);
}
